import { ReusableTable } from 'components/Tables/ReusableTable'
import React from 'react'
import ArticulosRow from './ArticulosRow'


   const HEADERS = ['Código','Nombre','Precio/u','Cantidad','Importe']
   const COLUMN_CLASSES =['ta-left','ta-left','ta-leftt','ta-right','ta-right']

export const ArticulosTable_v2 = ({articulos}) => {
    return (
    <ReusableTable  
        dataHeader={HEADERS}
        headerClassNames={COLUMN_CLASSES}
    >
        {articulos.map((articulo, i) => (
            <ArticulosRow articulo={articulo} key={i} />
          ))}
    
    </ReusableTable>
    )
}
